import React from "react";

/** A labelled on/off switch row (orange when on). */
const Toggle = ({ label, hint, checked, onChange }) => (
  <label className="flex cursor-pointer items-center justify-between gap-3 rounded-lg border border-[#F3F4F6] bg-[#F9FAFB] px-3.5 py-3">
    <span className="min-w-0">
      <span className="block text-[13px] font-medium text-[#374151]">
        {label}
      </span>
      {hint && <span className="block text-[11px] text-[#9CA3AF]">{hint}</span>}
    </span>
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      className={`relative h-5 w-9 flex-shrink-0 rounded-full transition-colors duration-150 ${
        checked ? "bg-[#E07A3A]" : "bg-[#D1D5DB]"
      }`}
    >
      <span
        className={`absolute top-0.5 h-4 w-4 rounded-full bg-white transition-all duration-150 ${
          checked ? "left-[18px]" : "left-0.5"
        }`}
      />
    </button>
  </label>
);

export default Toggle;
